"use client";
import classNames from "classnames";
import { usePathname, useRouter } from "@/i18n/navigation";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { FaChevronUp, FaChevronDown } from "react-icons/fa";
import { SearchAutocomplete } from "./SearchAutocomplete";
import { MainData } from "../CommonArray/FileArray";
import { setCurrentPage } from "./redux/reducer";
import styles from "./sidebar.module.css";
import { App as CapacitorApp } from "@capacitor/app";
import { useTranslations } from "next-intl";

const SidebarMenu = ({
  title,
  subMenuKey,
  subMenuOpen,
  handleSubMenu,
  items,
}) => {
  const router = useRouter();
  const pathName = usePathname();
  const checkPath = MainData.filter((item) => item.navigate === pathName)[0];

  return (
    <div className={styles.sidebarMenu}>
      <div
        className={styles.mainMenu}
        style={{
          backgroundColor: checkPath?.type === subMenuKey ? "#def9ff" : "",
        }}
      >
        <div
          className={styles.sidebarFlex}
          onClick={() => {
            handleSubMenu(subMenuKey);
          }}
        >
          <div className={styles.leftAlignment}>
            <span>{title}</span>
          </div>
          <div className={styles.rightAlignment}>
            {subMenuOpen?.[subMenuKey] ? (
              <FaChevronUp className={styles.icon} />
            ) : (
              <FaChevronDown className={styles.icon} />
            )}
          </div>
        </div>
        <div
          className={
            subMenuOpen?.[subMenuKey]
              ? classNames(styles.subMenu, styles.subMenuShow)
              : classNames(styles.subMenu, styles.subMenuHidden)
          }
        >
          {items.map((item, index) => (
            <span
              key={index}
              className={styles.subMenuItem}
              onClick={() => {
                router.push(item.navigate);
              }}
            >
              {item.Name}
            </span>
          ))}
        </div>
      </div>
    </div>
  );
};

export default function Sidebar() {
  const t = useTranslations("sidebar");
  const router = useRouter();
  const dispatch = useDispatch();
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [subMenuOpen, setSubMenuOpen] = useState<any>({});

  useEffect(() => {
    CapacitorApp.addListener("backButton", ({ canGoBack }) => {
      if (!canGoBack) {
        CapacitorApp.exitApp();
      } else {
        window.history.back();
      }
    });

    return () => {
      // @ts-ignore
      CapacitorApp.removeAllListeners("backButton");
    };
  }, []);

  const handleSubMenu = (key) => {
    setSubMenuOpen({ [key]: !subMenuOpen[key] });
    dispatch(setCurrentPage(key));
  };

  const formatResult = (item) => {
    return (
      <span style={{ display: "block", textAlign: "left" }}>{item.name}</span>
    );
  };

  const handleOnSelect = (item: { name: string; route: string }) => {
    router.push(item.route);
  };

  // useEffect(() => {
  //   const checkPath = images.filter((item) => item.navigate === pathName)[0];
  //   setSubMenuOpen({ [checkPath?.type]: !subMenuOpen[checkPath?.type] });
  // }, [sidebar]);

  return (
    <>
      <div
        className={
          sidebarOpen
            ? classNames(styles.sidebar, styles.sidebarHiddenShow)
            : classNames(styles.sidebar, styles.sidebarHiddenStyle)
        }
      >
        <div className="sidebar-search-sticky-top">
          <div className={`result-search-box-inner ${styles.searchBoxFullWidth}`}>
            <SearchAutocomplete
              placeholder={t("searchPlaceholder")}
              items={MainData?.map((item) => ({
                name: item?.Name ?? "",
                route: item?.navigate ?? "",
              })) ?? []}
              onSelect={handleOnSelect}
              formatResult={formatResult}
            />
          </div>
        </div>
        <SidebarMenu
          title={t("calculatorTools")}
          subMenuKey="calculator"
          subMenuOpen={subMenuOpen}
          handleSubMenu={handleSubMenu}
          items={MainData.filter((item) => item.type === "calculator")}
        />
        <SidebarMenu
          title={t("textAnalyticsTools")}
          subMenuKey="texttools"
          subMenuOpen={subMenuOpen}
          handleSubMenu={handleSubMenu}
          items={MainData.filter((item) => item.type === "texttools")}
        />
        <SidebarMenu
          title={t("numberTools")}
          subMenuKey="onlinenumber"
          subMenuOpen={subMenuOpen}
          handleSubMenu={handleSubMenu}
          items={MainData.filter((item) => item.type === "onlinenumber")}
        />
        <SidebarMenu
          title={t("unitConvertorTools")}
          subMenuKey="unit"
          subMenuOpen={subMenuOpen}
          handleSubMenu={handleSubMenu}
          items={MainData.filter((item) => item.type === "unit")}
        />
        <SidebarMenu
          title={t("binaryConvertorTools")}
          subMenuKey="binary"
          subMenuOpen={subMenuOpen}
          handleSubMenu={handleSubMenu}
          items={MainData.filter((item) => item.type === "binary")}
        />
        <SidebarMenu
          title={t("developmentTools")}
          subMenuKey="development"
          subMenuOpen={subMenuOpen}
          handleSubMenu={handleSubMenu}
          items={MainData.filter((item) => item.type === "development")}
        />
        <SidebarMenu
          title={t("proxyTools")}
          subMenuKey="proxy"
          subMenuOpen={subMenuOpen}
          handleSubMenu={handleSubMenu}
          items={MainData.filter((item) => item.type === "proxy")}
        />
        <SidebarMenu
          title={t("otherTools")}
          subMenuKey="other"
          subMenuOpen={subMenuOpen}
          handleSubMenu={handleSubMenu}
          items={MainData.filter((item) => item.type === "other")}
        />
        <SidebarMenu
          title={t("timeConvertorTools")}
          subMenuKey="timeConvertor"
          subMenuOpen={subMenuOpen}
          handleSubMenu={handleSubMenu}
          items={MainData.filter((item) => item.type === "timeConvertor")}
        />
        <SidebarMenu
          title={t("currencyConvertorTools")}
          subMenuKey="currencyconvert"
          subMenuOpen={subMenuOpen}
          handleSubMenu={handleSubMenu}
          items={MainData.filter((item) => item.type === "currencyconvert")}
        />
        <SidebarMenu
          title={t("countryTools")}
          subMenuKey="countrytool"
          subMenuOpen={subMenuOpen}
          handleSubMenu={handleSubMenu}
          items={MainData.filter((item) => item.type === "countrytool")}
        />
        <SidebarMenu
          title={t("socialMediaTools")}
          subMenuKey="socialmedia"
          subMenuOpen={subMenuOpen}
          handleSubMenu={handleSubMenu}
          items={MainData.filter((item) => item.type === "socialmedia")}
        />
        <SidebarMenu
          title={t("cryptoTools")}
          subMenuKey="cryptotools"
          subMenuOpen={subMenuOpen}
          handleSubMenu={handleSubMenu}
          items={MainData.filter((item) => item.type === "cryptotools")}
        />
        <SidebarMenu
          title={t("languageTools")}
          subMenuKey="language"
          subMenuOpen={subMenuOpen}
          handleSubMenu={handleSubMenu}
          items={MainData.filter((item) => item.type === "language")}
        />
        <SidebarMenu
          title={t("coderTools")}
          subMenuKey="codertools"
          subMenuOpen={subMenuOpen}
          handleSubMenu={handleSubMenu}
          items={MainData.filter((item) => item.type === "codertools")}
        />
      </div>
    </>
  );
}
